import { EditBooking } from 'components/detail/edit/EditDetail/EditBooking';
import { EditDetailCards } from 'components/detail/edit/EditDetail/EditDetailCards';
import { EditDetailHeader } from 'components/detail/edit/EditDetail/EditHeaderDetail';
import { Message } from 'elements/minute/sidebar/sidebarComponents/atomic/Message';
import { useWorldMarker } from 'hooks/marker/useWorldMarker';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const EditDetail = (props: Props): JSX.Element => {
    const worldMarker = useWorldMarker();
    const selectedMarker = worldMarker.getSingleMarkerIfOne();

    if (selectedMarker.isExternalPoint) {
        return (
            <S_EditDetail className={props.className}>
                <S_MessageContainer>
                    <Message type="info">{Localization.GLOBAL_POINTS_EDIT_NOT_SUPPORTED}</Message>
                </S_MessageContainer>
            </S_EditDetail>
        );
    }

    return (
        <S_EditDetail className={props.className}>
            <EditDetailHeader />
            <EditDetailCards />
            {selectedMarker && selectedMarker.hasBookingConfiguration && <EditBooking />}
        </S_EditDetail>
    );
};

const S_EditDetail = styled.div``;

const S_MessageContainer = styled.div`
    margin: 0 20px;
`;
